/*------------ Mobile Sidebar ----------------*/

var stat;

function handleMousePos(event) {
    if (stat == 1) {
        var mouseClickWidth = event.clientX;
        const box = document.getElementById('mySidebar');
        if (!box.contains(event.target)) {
            closeNav();
        }
    }
}

document.addEventListener("click", handleMousePos);

function openNav() {
    document.getElementById("mySidebar").style.width = "100%";
    document.getElementById("mySidebar").style.transition = "0.3s";
    document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,30,60,.9) ";
    document.getElementById("sidebarMain").style.opacity = "1";
    document.getElementById("sidebarMain").style.transition = "0.2s";

    var delayInMilliseconds = 100; //1 second

    setTimeout(function() {
        stat = 1;
    }, delayInMilliseconds);
    document.getElementById('sidebarMainbtn').style.opacity = "1";
    document.getElementById('sidebarMainbtn').style.visibility = "visible";
    document.getElementById("sidebarMainbtn").style.transition = "0.5s";

}

function closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("mySidebar").style.boxShadow = "none ";
    document.getElementById("sidebarMain").style.opacity = "0 ";
    document.getElementById("sidebarMain").style.transition = "0.2s";
    stat = 0;
    document.getElementById('sidebarMainbtn').style.opacity = "0";
    document.getElementById('sidebarMainbtn').style.visibility = "hidden";
    document.getElementById("sidebarMainbtn").style.transition = "0.2s";

}
var abc;

function OpenLi(clickedID) {
    var elementid = document.getElementById(clickedID);
    let str = clickedID;
    str = str.substring(1);
    var Nav2Id = document.getElementById(str);
    Nav2Id.style.width = "100%";
    Nav2Id.style.left = "0";
    abc = Nav2Id;

    document.getElementById('sidebarMainbtn').style.opacity = "0";
    document.getElementById('sidebarMainbtn').style.visibility = "hidden";
    document.getElementById("sidebarMainbtn").style.transition = "0.2s";

    document.getElementById('sidebarNav2btn').style.opacity = "1";
    document.getElementById('sidebarNav2btn').style.visibility = "visible";
    document.getElementById("sidebarNav2btn").style.transition = "0.2s";
}

function backtoNav() {
    var ccc = abc;
    ccc.style.width = "0";
    ccc.style.left = "-100px";
    document.getElementById('sidebarMainbtn').style.opacity = "1";
    document.getElementById('sidebarMainbtn').style.visibility = "visible";
    document.getElementById("sidebarMainbtn").style.transition = "0.2s";

    document.getElementById('sidebarNav2btn').style.opacity = "0";
    document.getElementById('sidebarNav2btn').style.visibility = "hidden";
    document.getElementById("sidebarNav2btn").style.transition = "0.2s";

}

function closeNav2() {
    backtoNav();
    closeNav();
}

/*------------ Sliders ----------------*/

// $('.HomeSec1Sl').slick({
//     prevArrow: '<button class="HSec1Left"><i class="fa-solid fa-chevron-left"></i></button>',
//     nextArrow: '<button class="HSec1Right"><i class="fa-solid fa-chevron-right"></i></button>',
//     autoplay: true,
//     autoplaySpeed: 3000,
//     dots: false,

// });
// $('.HomeSec2Sl').slick({
//     mobileFirst: true,
//     prevArrow: '<button class="HSec2Left"><i class="fa-solid fa-chevron-left"></i></button>',
//     nextArrow: '<button class="HSec2Right"><i class="fa-solid fa-chevron-right"></i></button>',
//     autoplay: true,
//     autoplaySpeed: 3000,
//     dots: false,
//     responsive: [{
//         breakpoint: 767,

//         settings: "unslick",

//     }]

// });
// $('.slider-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     asNavFor: '.slider-nav'
// });
// $('.slider-nav').slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     asNavFor: '.slider-for',
//     dots: false,
//     infinite: true,
//     focusOnSelect: true,
//     arrows: false,

//     vertical: true,
//     verticalSwiping: true,
//     responsive: [{
//         breakpoint: 1200,
//         settings: {
//             slidesToShow: 5,
//         },

//     }, {
//         breakpoint: 1023,
//         settings: {
//             slidesToShow: 4,
//         },

//     }, {
//         breakpoint: 600,
//         settings: {
//             slidesToShow: 4,
//             vertical: false,
//             verticalSwiping: false,
//         },

//     }, ],
// });

/*window.onclick = function(event) {

    if (event.target == modal) {


        var textVal = $("#field").val();
        if ($('#giftwrap2').is(':checked')) {
            if (textVal == "") {
                $("#error").fadeIn(500).show();
                $("#field").addClass("errorBorder");
                return false;
            } else {
                modal.style.display = "none";
                $("#error").fadeIn(500).hide();
                $("#field").removeClass("errorBorder");

            }
        } else {
            modal.style.display = "none";
            $("#error").fadeIn(500).hide();
            $("#field").removeClass("errorBorder");
        }

    }
}*/
